<template>
  <Accordion title="Dados da Movimentação">
    <div class="grid grid-cols-4 gap-5">
      <InputNumber v-if="localValue.id" label="Código" placeholder="Insira Código" v-model="localValue.id" :disabled="localValue.id" />
      <Select :items="filteredTypes" v-model="localValue.type" label="Tipo" required :error="localErrors.type" :disabled="localValue.id" />

      <InputZoom
        required
        clearable
        label="Local Origem"
        v-model="localValue.idOriginWarehouse"
        :error="localErrors.idOriginWarehouse"
        v-model:complete-object="completeObject"
        database="warehouse"
        item-value="id"
        item-text="name"
        placeholder="Selecione o depósito"
        :disabled="localValue.id" />
      <InputZoom
        clearable
        v-model="localValue.idDestinationWarehouse"
        label="Local Destino"
        :error="localErrors.idDestinationWarehouse || localErrors.sameWarehouse"
        :disabled="!localValue.idOriginWarehouse || localValue.id"
        :filter="computedItemsFilters"
        database="warehouse"
        item-text="name"
        item-value="id"
        placeholder="Selecione o depósito" />

      <InputDateTime v-model="localValue.date" label="Data" required :error="localErrors.date" disabled />

      <InputZoom
        clearable
        v-model="localValue.idEmployee"
        label="Funcionário Responsável"
        :error="localErrors.idEmployee"
        required
        database="employee"
        item-text="name"
        item-value="id"
        placeholder="Selecione o funcionário"
        :disabled="localValue.id" />

      <InputZoom
        v-model="localValue.idUser"
        clearable
        label="Responsável"
        :error="localErrors.idUser"
        required
        database="user"
        item-text="name"
        item-value="id"
        placeholder="Selecione o responsável"
        :disabled="localValue.id" />

      <TextArea class="col-span-4" v-model="localValue.description" label="Descrição" placeholder="Insira uma descrição" :error="localErrors.description" />
    </div>
  </Accordion>
</template>

<script setup>
import { computed, reactive, ref, watch, onMounted } from 'vue'
import { useFormat } from '@/composables/useFormat'
import { useStore } from 'vuex'
import moment from 'moment'

const store = useStore()
const user = computed(() => store.state.user)

const { formatDatetimeToTimezone } = useFormat()

const props = defineProps({
  modelValue: Object,
  error: Object,
})

const emits = defineEmits(['update:modelValue'])

const localValue = reactive(props.modelValue)
const localErrors = ref(props.error)
const completeObject = ref(null)

// Módulo para Corrigir tipos
const allTypes = [
  { label: 'Fornecimento', value: 'outgoing' },
  { label: 'Transferência', value: 'transfer' },
  { label: 'Devolução', value: 'devolution' },
  { label: 'Devolução ao Fornecedor', value: 'supplierDevolution' },
  { label: 'Baixa', value: 'downward' },
]

const allowedTypesByWarehouse = {
  team: ['devolution', 'transfer', 'downward'],
  physic: ['outgoing', 'devolution', 'supplierDevolution', 'transfer'],
  vehicles: ['devolution', 'transfer', 'downward'],
}

const filteredTypes = computed(() => {
  if (!completeObject.value || !completeObject.value.type) {
    return allTypes
  }

  const warehouseType = completeObject.value.type
  const allowedValues = allowedTypesByWarehouse[warehouseType] || []

  return allTypes.filter((type) => allowedValues.includes(type.value))
})

watch(completeObject, (newWarehouse) => {
  if (newWarehouse && newWarehouse.type && localValue.type) {
    const allowedValues = allowedTypesByWarehouse[newWarehouse.type] || []
    if (!allowedValues.includes(localValue.type)) {
      localValue.type = null
    }
  }
})

const computedItemsFilters = computed(() => {
  if (completeObject.value && localValue.idOriginWarehouse) {
    return [
      { column: 'type', operator: '=', value: 'physic' },
      { column: 'id', operator: '!=', value: localValue.idOriginWarehouse },
    ]
  }
  return []
})

//  Watchers
onMounted(() => {
  // localValue.date = moment()
  localValue.idUser = user.value.id
})

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  },
)

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue
  },
)

// watch(
//   () => localValue.value.idOriginWarehouse,
//   () => {
//     localValue.value.idDestinationWarehouse = null
//   },
//   {immediate: true},
// )

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})
</script>
